import React, { useState } from "react";
import { StyleSheet, View } from "react-native";
import Text from "theme/Text";
import i18n from "utils/i18n";
import { layoutStyles } from "styles/layout";
import { textStyles } from "styles/text";
import Button from "theme/Button";
import _ from 'lodash'

const FetchError = ({ action }) => {
	
	const [ retrying, setRetrying ] = useState( false )
	
	const retry = () => {
		if( action && _.isFunction( action ) ) {
			
			setRetrying( true )
			action( { callback: retryCallback } );
		}
	}
	
	const retryCallback = () => {
		setRetrying( false )
	}
	
	return (
		<View
			style={ layoutStyles.containerCenter }>
			
			<Text
				style={ [
					textStyles.textCenter,
					styles.text
				]}>
				
				{ i18n.t('error.retry_text')}
			</Text>
			
			<Button
				isLoading={ retrying }
				onPress={ retry }>
				
				{ i18n.t('error.retry_button') }
			</Button>
		</View>
	);
}

const styles = StyleSheet.create({
	svgIcon: {
		maxWidth: 150,
		maxHeight: 150,
		margin: 8
	},
	
	text: {
		width: '90%',
	}
});

export default FetchError
